import PropTypes from "prop-types";
import React from 'react';
import { Header, List, Segment, Label } from 'semantic-ui-react';
import { useCurrentHotel } from '../../hooks/useCurrentHotel';
import { useTextResources } from "../../language";
import * as reservationPolicyUtils from '../shared/reservationPolicy'
import './style.css';

const DepositPoliciesList = ({ depositPolicies, reservationTotal, reservation }) => {

    const currentHotel = useCurrentHotel();
    const text = useTextResources()

    return (
        <Segment style={{ width: '100%' }}>
            <Label ribbon color='teal' style={{ minWidth: 120, textAlign: 'center' }}> 
                {text("Deposit")}
            </Label>
            <List bulleted>
                {depositPolicies?.map(cp => (
                    <List.Item key={cp.Id} >
                        <span>{reservationPolicyUtils.getDepositPolicyDescription(cp,
                            reservation,
                            reservationTotal)}
                        </span>
                    </List.Item>
                ))}
            </List>
            <Header className='policy-info-header'>
                <Header.Subheader>
                    {text('TotalRecievedPayments')}:
                </Header.Subheader>
                <Header.Content>
                    <Segment color='black'>
                        {reservationPolicyUtils.getTotalPayedText(reservationTotal, currentHotel.MainCurrencyId)}
                    </Segment>
                </Header.Content>
            </Header>
        </Segment>
    )
}
DepositPoliciesList.propTypes = {
    reservationTotal: PropTypes.object,
    depositPolicies: PropTypes.array,
    reservation: PropTypes.object
}

export default DepositPoliciesList
